export const storeItem = (key: string, value: any) => (value ? localStorage.setItem(key, JSON.stringify(value)) : null);

export const getStoredItem = <T>(key: string): T | null => {
  const item = localStorage.getItem(key);
  return item ? (JSON.parse(item) as T) : null;
};

export const removeStoredItem = (key: string) => localStorage.removeItem(key);
